{
  "comment": "Goods in M2's hold (economy plan SY-2a; first the M3 relay parts, D-TBD 40): tonnes per unit of every good, i.e. every non-raw strategic ware (src/career/parts.ts GOOD_IDS) in strategic order. The career keeps the goods in cargo.parts, separate from M2's raw wares, and they count against the hold's capacity. All 1 t for now (per-good tuning is MC-b1). Relay parts are priced by the strategic market whenever it runs (SY-2e); reach-standin.json partPrices prices only the offline stand-in.",
  "massT": {
    "steel": 1,
    "ti_alloy": 1,
    "silicon_wafers": 1,
    "water": 1,
    "fuel_cells": 1,
    "hull_plating": 1,
    "electronics": 1,
    "drive_parts": 1,
    "weapon_parts": 1,
    "food": 1,
    "medical": 1,
    "refractory_alloy": 1,
    "rush_spares": 1
  }
}
